import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Equipment from '../entities/equipment'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface EquipmentState extends ListState<Equipment>{
    editEquipment:Equipment
    analyseEquipment:Equipment
}
class UserMutations extends ListMutations<Equipment>{

}
class EquipmentModule extends ListModule<EquipmentState,any,Equipment>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Equipment>(),
        loading:false,
        editEquipment:new Equipment(),
        analyseEquipment:new Equipment()
    }
    actions={
        async getAll(context:ActionContext<EquipmentState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Equipment/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Equipment>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            return page.items;
        },
        async create(context:ActionContext<EquipmentState,any>,payload:any){
            await Ajax.post('/api/services/app/Equipment/Create',payload.data);
        },
        async uploadimg(context:ActionContext<EquipmentState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<EquipmentState,any>,payload:any){
            await Ajax.put('/api/services/app/Equipment/Update',payload.data);
        },
        async updateNumbler(context:ActionContext<EquipmentState,any>,payload:any){
            await Ajax.put('/api/services/app/Equipment/UpdateNumbler',payload.data);
        },
        async delete(context:ActionContext<EquipmentState,any>,payload:any){
            await Ajax.delete('/api/services/app/Equipment/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<EquipmentState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Equipment/GetById?Id='+payload.id);
            return reponse.data.result as Equipment;
        },
        ///获取设备数量
        async getCount(context:ActionContext<EquipmentState,any>,payload:any){
            //console.log(payload);
            let reponse=await Ajax.get('/api/services/app/Equipment/GetCount?status='+payload.data.status);
            return reponse.data.result.count;
        },
        ///获取所有设备数量
        async getAllEquCount(context:ActionContext<EquipmentState,any>){
            let reponse=await Ajax.get('/api/services/app/Equipment/GetAllEquCount');
            return reponse.data.result;
        }
    };
    mutations={
        setCurrentPage(state:EquipmentState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:EquipmentState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:EquipmentState,equipment:Equipment){
            
            state.editEquipment=equipment;
            //console.log(state.editFloor);
        },
        analyse(state: EquipmentState, equipment: Equipment) {
            state.analyseEquipment = equipment;
        },
    }
}
const equipmentModule=new EquipmentModule();
export default equipmentModule;